// admin/src/lib/staging.ts
//
// A picked image, compressed and held locally (with an object URL for the
// preview) until the admin confirms the upload.
import { compressImage, type CompressedImage, type ImageTarget } from './image';
import { validateUploadSize } from './validators';

export type StagedImage = CompressedImage & { url: string };

export async function stageImage(file: Blob, target: ImageTarget): Promise<StagedImage> {
  const sizeError = validateUploadSize(file.size);
  if (sizeError) throw new Error(sizeError);
  const compressed = await compressImage(file, target);
  return { ...compressed, url: URL.createObjectURL(compressed.blob) };
}

export function releaseStaged(staged: { url: string } | null | undefined): void {
  if (staged) URL.revokeObjectURL(staged.url);
}
